import React from 'react';
import styles from './styles/FinalStatus.module.css';

// Simulando tus datos de 'odd' del objeto info anterior
// const infoData = {
//   info: '',
//   status: 'En proceso',
//   acumulado: '660.1531 hrs.'
// };

const FinalStatus1 = (props) => {

const formatEventDuration = (hoursDecimal) => {
  const totalMinutes = Math.floor(hoursDecimal * 60);
  
  const days = Math.floor(totalMinutes / (24 * 60));
  const remainingMinutesAfterDays = totalMinutes % (24 * 60);
  
  const hours = Math.floor(remainingMinutesAfterDays / 60);
  const minutes = remainingMinutesAfterDays % 60;

  // Construimos el string resultado
  let result = "";
  if (days > 0) result += `${days}d `;
  if (hours > 0 || days > 0) result += `${hours}h `;
  result += `${minutes}m`;

  return result.trim();
};
    const infoData = {
  info: '',
  status: props.status==='RESOLVED'?'RESUELTO':'En proceso',
  acumulado: formatEventDuration(props.hrs.replace('hrs.',''))
};
// Ejemplo de uso:
// 660.1531 -> "27d 12h 9m"
// console.log(formatEventDuration(660.1531));
  return (
    <div className={`${props.status==='RESOLVED'?styles.statusContainerResolved:styles.statusContainer}`}>
      {/* El badge de estado se coloca arriba, a la izquierda */}
      <span className={`${styles.statusBadge} ${props.status==='RESOLVED'?styles.statusResolved:styles.statusInProcess}`}>
        {infoData.status}
      </span>
      
      {/* Texto de información adicional renderizado de forma segura */}
      <p 
        className={styles.oddRemindText}
        dangerouslySetInnerHTML={{ __html: infoData.info }}
      />
      
      {/* Sección de acumulado más tenue al final */}
      <div className={styles.accumulatedSection}>
        <span className={styles.accumulatedLabel}>Acumulado evento</span>
        <span className={styles.accumulatedValue}>{infoData.acumulado}</span>
      </div>
    </div>
  );
};

export default FinalStatus1;